/**
 * @desc: 商户及供应商信息公用接口
 * @created: 2020/09/03
 * @author:yeungyifan
 * @version : v1.0
 */

import * as Models from '@/api/public'
import { push } from 'core-js/fn/array';

export default {
  namespaced: true,
  state: {
    aliOSS: null,
    periods: null
  },
  actions: {
    // 获取商户/供应商设备信息
    async getAppUserInfo(ctx, payload) {
      const data = await Models.getAppUserInfo(payload);
      return data && data.status === 200 && data.data || {}
    },
    // 获取阿里云OSS配置
    async getAliOSSPolicy({ state, commit }, payload) {
      // console.log(state, payload, '获取阿里云OSS配置');
      if (state.aliOSS) { return { status: 200, data: state.aliOSS } }

      return Models.getAliOSSPolicy(payload).then(res => {
        commit('setAliOSS', res.data)
        return res
      })
    },
    // 获取商户基本信息
    async getMerchantDetails(ctx, payload) {
      const data = await Models.getMerchantDetails(payload)
      return data && data.status === 200 && data.data || {}
    },
    // 获取供应商基本信息  是哪块代码
    async getSupplierDetails(ctx, payload) {
      const data = await Models.getSupplierDetails(payload)
      return data && data.status === 200 && data.data || {}
    },
    // 获取商户供应商详情要素校验信息
    getVerification(ctx, payload) {
      return Models.getVerification(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 获取T6期号列表
    async getPeriodsList({ state }, payload) {
      if (state.periods) return state.periods;

      const data = await Models.getPeriodsList(payload);

      const result = data.data.reduce((prev, item) => {
        prev.push({
          label: item.periodNo,
          value: item.periodNo
        });

        return prev
      }, [{ label: '全部', value: '' }])

      state.periods = result;

      return result;
    },


    // 根据手机号拿到拓展人员信息
    getExpandUser(ctx, payload) {
      return Models.getExpandUser(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 城市下拉
    getSelectActiveCity(ctx, payload) {
      return Models.getSelectActiveCity(payload).then(res => {
        console.log(res, 'res');
      })
    }
  },
  mutations: {
    setAliOSS(state, payload) {
      state.aliOSS = payload
    }

  }
}
